<template>
  <v-col>
    <section>
      <div
        class="text-h6 link text-decoration-underline third--text"
        @click="goToStep('rdd')"
      >
        Requested Due Date
      </div>
      <div class="pt-3">
        <ValidationIcon :value="generalData.has_due_date" />
        Do you have a Requested Due Date?&ensp;
        <span class="font-weight-bold">{{
          generalData.has_due_date === "y" ? "Yes" : "No"
        }}</span>
      </div>
      <div v-if="generalData.has_due_date === 'y'">
        <ValidationIcon :value="generalData.requested_due_date" />
        Due Date:&ensp;
        <span class="font-weight-bold">{{
          generalData.requested_due_date
        }}</span>
      </div>
      <v-divider />
    </section>
    <section>
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('tax_qs')"
      >
        Tax Questions
      </div>
      <div class="pt-3">
        <ValidationIcon :value="generalData.usf_charge" />
        Are you exempt from USF charges?&ensp;
        <span class="font-weight-bold">
          {{ generalData.usf_charge === "exempt" ? "Yes" : "No" }}
        </span>
      </div>
      <template v-if="!isExistingCustomer">
        <div class="pt-3">
          <ValidationIcon :value="generalData.statetax" />
          Are you exempt from state taxes?&ensp;
          <span class="font-weight-bold">
            {{ generalData.statetax === "exempt" ? "Yes" : "No" }}
          </span>
        </div>
        <div class="pt-3">
          <ValidationIcon :value="generalData.fedtax" />
          Are you exempt from federal excise taxes?&ensp;
          <span class="font-weight-bold">
            {{ generalData.fedtax === "exempt" ? "Yes" : "No" }}
          </span>
        </div>
        <div class="pt-3">
          <ValidationIcon :value="generalData.emergency_fee" />
          Are you exempt from MI 911 Fees?&ensp;
          <span class="font-weight-bold">
            {{ generalData.emergency_fee === "exempt" ? "Yes" : "No" }}
          </span>
        </div>
        <div class="pt-3">
          <ValidationIcon :value="generalData.stateaccess_charge" />
          Are you exempt from MI Access charges?&ensp;
          <span class="font-weight-bold">
            {{ generalData.stateaccess_charge === "exempt" ? "Yes" : "No" }}
          </span>
        </div>
      </template>

      <v-divider />
    </section>
    <!-- <section v-if="generalData.usf_charge === 'exempt'">
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('usf_form')"
      >
        USF Form
      </div>
      <div class="pt-3">
        <ValidationIcon :value="generalData.company_name" />
        What is the company name?&ensp;
        <span class="font-weight-bold">
          {{ generalData.company_name }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.usf_address" />
        What is the company address?&ensp;
        <span class="font-weight-bold">
          {{
            generalData.usf_address +
            " " +
            generalData.usf_city +
            ", " +
            generalData.usf_state +
            " " +
            generalData.usf_zip
          }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.exempt_account" />
        Which account is exempt?&ensp;
        <span class="font-weight-bold">
          {{ generalData.exempt_account }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.filer_id" />
        What is the FCC 499 Filer ID?&ensp;
        <span class="font-weight-bold">
          {{ generalData.filer_id }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.has_usf_upload" />
        Do you have a copy of your Annual Universal Service Charge Exemption
        Certificate to upload?&ensp;
        <span class="font-weight-bold">
          {{ generalData.has_usf_upload === "yes" ? "Yes" : "No" }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.services_exempt" />
        What services are exempt?&ensp;
        <span class="font-weight-bold">
          {{ generalData.services_exempt === "y" ? "All" : "Listed" }}
        </span>
      </div>
      <div v-if="generalData.services_exempt === 'n'">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Product</th>
                <th class="text-left">USF Exempt</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in products" :key="product.product_id">
                <td>{{ product.product_name }}</td>
                <td>
                  {{product.usf_exempt === 'y' ? "Yes" : "No"}}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-divider />
    </section> -->

    <!-- <section v-if="generalData.statetax === 'exempt'">
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('statetax_form')"
      >
        State Tax Form
      </div>
      <div class="pt-3">
        <ValidationIcon :value="generalData.statetax_name_of_firm" />
        What is the name of the firm?&ensp;
        <span class="font-weight-bold">
          {{ generalData.statetax_name_of_firm }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.statetax_address" />
        What is the company address?&ensp;
        <span class="font-weight-bold">
          {{
            generalData.statetax_address +
            " " +
            generalData.statetax_city +
            ", " +
            generalData.statetax_state +
            " " +
            generalData.statetax_zip
          }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.statetax_company_type" />
        What is the company registered as?&ensp;
        <span class="font-weight-bold">
          {{ generalData.statetax_company_type }}
        </span>
      </div>
      <div v-if="generalData.statetax_company_type === 'other'">
        <ValidationIcon :value="generalData.statetax_other_type" />
        Specify:&ensp;
        <span class="font-weight-bold">
          {{ generalData.statetax_other_type }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.statetax_desc_of_business" />
        Description of business:&ensp;
        <span class="font-weight-bold">
          {{ generalData.statetax_desc_of_business }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.statetax_purchased_desc" />
        General description of tangible property or taxable services to be purchased from the
        seller:&ensp;
        <span class="font-weight-bold">
          {{ generalData.statetax_purchased_desc }}
        </span>
      </div>
      <div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">State</th>
                <th class="text-left">ID Number</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="state in addedStates" :key="state">
                <td>{{ state }}</td>
                <td>{{ generalData[`statetax_${state.toLowerCase()}_id`] }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-divider />
    </section> -->

    <!-- <section v-if="generalData.fedtax === 'exempt'">
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('fed_form')"
      >
        Federal Excise Tax Form
      </div>
      <div class="pt-3">
        <ValidationIcon :value="generalData.fedtax_company_name" />
        What is the company name?&ensp;
        <span class="font-weight-bold">
          {{ generalData.fedtax_company_name }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.fedtax_address" />
        What is the company address?&ensp;
        <span class="font-weight-bold">
          {{
            generalData.fedtax_address +
            " " +
            generalData.fedtax_city +
            ", " +
            generalData.fedtax_state +
            " " +
            generalData.fedtax_zip
          }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.fedtax_accounts_exempt" />
        Exemption requested for the following accounts:&ensp;
        <span class="font-weight-bold">
          {{ generalData.fedtax_accounts_exempt }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.fedtax_exemption_type" />
         Let us know if this is a new certificate or a renewal.&ensp;
        <span class="font-weight-bold">
          {{ generalData.fedtax_exemption_type }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="getProvisionText" />
        Select the appropriate section and provide required information where applicable:&ensp;
        <span class="font-weight-bold">
          {{ getProvisionText }}
        </span>
      </div>
      <v-divider />
    </section> -->

    <!-- <section v-if="generalData.emergency_fee === 'exempt'">
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('mi911_form')"
      >
        MI911 Fee Form
      </div>
      <div class="pt-3">
        <ValidationIcon :value="generalData.emergencytax_company_name" />
        What is the company name?&ensp;
        <span class="font-weight-bold">
          {{ generalData.emergencytax_company_name }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.emergencytax_accounts_exempt" />
        What accounts are exempt?&ensp;
        <span class="font-weight-bold">
          {{ generalData.emergencytax_accounts_exempt }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.emergencytax_address" />
        What is the company address?&ensp;
        <span class="font-weight-bold">
          {{
            generalData.emergencytax_address +
            " " +
            generalData.emergencytax_city +
            ", " +
            generalData.emergencytax_state +
            " " +
            generalData.emergencytax_zip
          }}
        </span>
      </div>
      <v-divider />
    </section> -->

    <!-- <section v-if="generalData.stateaccess_charge === 'exempt'">
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('mi_access_charges')"
      >
        MI Access Charges Form
      </div>
      <div class="pt-3">
        <ValidationIcon :value="generalData.stateaccesstax_company_name" />
        What is the company name?&ensp;
        <span class="font-weight-bold">
          {{ generalData.stateaccesstax_company_name }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.stateaccesstax_accounts_exempt" />
        Which accounts are exempt?&ensp;
        <span class="font-weight-bold">
          {{ generalData.stateaccesstax_accounts_exempt }}
        </span>
      </div>
      <div>
        <ValidationIcon :value="generalData.stateaccesstax_registration_number" />
        What is your state registration number?&ensp;
        <span class="font-weight-bold">
          {{ generalData.stateaccesstax_registration_number }}
        </span>
      </div>
      <v-divider />
    </section> -->

    <section>
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('contacts')"
      >
        Contacts
      </div>
      <div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Phone</th>
                <th class="text-left">Email</th>
                <th class="text-left">Roles</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="contact in generalData.contacts" :key="contact.row_id">
                <td>{{ `${contact.first} ${contact.last}` }}</td>
                <td>{{ contact.phone }}</td>
                <td>{{ contact.email }}</td>
                <td>{{ contact.roles.join(", ") }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-divider />
    </section>
    <section>
      <!--<div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('ap_billing')"
      >
        AP/Billing Info
      </div>
      <div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Contact</th>
                <th class="text-left">Company</th>
                <th class="text-left">Phone</th>
                <th class="text-left">Email</th>
                <th class="text-left">Address</th>
                <th class="text-left">Purchase Order</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="contact in generalData.contacts" :key="contact.row_id">
                <td>{{ getFormData.general.ap_contact }}</td>
                <td>{{ getFormData.general.ap_name }}</td>
                <td>{{ getFormData.general.ap_phone }}</td>
                <td>{{ getFormData.general.ap_email }}</td>
                <td>{{ getFormData.general.ap_address }}</td>
                <td>{{ getFormData.general.purchase_order }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-divider />-->

      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('ap_billing')"
      >
        Billing Info
      </div>
      <div>
        <ValidationIcon :value="generalData.ap_contact" />
        Billing Contact:&ensp;
        <span class="font-weight-bold">{{
          generalData.ap_contact
        }}</span>
      </div>
      <div>
        <ValidationIcon :value="generalData.ap_phone" />
        Billing Phone:&ensp;
        <span class="font-weight-bold">{{
          generalData.ap_phone
        }}</span>
      </div>
      <div>
        <ValidationIcon :value="generalData.ap_name" />
        Billing Company Name:&ensp;
        <span class="font-weight-bold">{{
          generalData.ap_name
        }}</span>
      </div>
      <div>
        <ValidationIcon :value="generalData.ap_address" />
        Billing Address:&ensp;
        <span class="font-weight-bold">{{
          generalData.ap_address
        }}</span>
      </div>
      <div>
        <ValidationIcon :value="generalData.purchase_order_required" />
        Purchase Order Required?&ensp;
        <span class="font-weight-bold">{{
          generalData.purchase_order_required ? "Yes" : "No"
        }}</span>
      </div>
      <div v-if="generalData.purchase_order_required">
        <ValidationIcon :value="generalData.purchase_order" />
        Purchase Order:&ensp;
        <span class="font-weight-bold">{{
          generalData.purchase_order
        }}</span>
      </div>
    </section>
    <section v-if="isRetail">
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('vendor_info')"
      >
        IT Vendor Info
      </div>
      <div>
        <ValidationIcon :value="generalData.has_vendor" />
        Do you have an IT Vendor?&ensp;
        <span class="font-weight-bold">
          {{ generalData.has_vendor === "y" ? "Yes" : "No" }}
        </span>
      </div>
      <div v-if="generalData.has_vendor === 'y'">
        <div>
          <ValidationIcon :value="generalData.vendor_company_name" />
          Vendor Company Name:&ensp;
          <span class="font-weight-bold">{{
            generalData.vendor_company_name
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.vendor_company_number" />
          Vendor Company Number:&ensp;
          <span class="font-weight-bold">{{
            generalData.vendor_company_number
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.vendor_contact_name" />
          Vendor Contact Name:&ensp;
          <span class="font-weight-bold">{{
            generalData.vendor_contact_name
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.vendor_contact_number" />
          Vendor Contact Number:&ensp;
          <span class="font-weight-bold">{{
            generalData.vendor_contact_number
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.vendor_contact_email" />
          Vendor Contact Email:&ensp;
          <span class="font-weight-bold">{{
            generalData.vendor_contact_email
          }}</span>
        </div>
      </div>
    </section>

    <section v-if="isRetail">
      <div
        class="text-h6 text-decoration-underline link third--text"
        @click="goToStep('pbx_vendor_info')"
      >
        PBX - Phone System Vendor Info
      </div>
      <div>
        <ValidationIcon :value="generalData.has_pbx_vendor" />
        Do you have a PBX - Phone System Vendor?&ensp;
        <span class="font-weight-bold">
          {{ generalData.has_pbx_vendor === "y" ? "Yes" : "No" }}
        </span>
      </div>
      <div v-if="generalData.has_pbx_vendor === 'y'">
        <div>
          <ValidationIcon :value="generalData.pbx_vendor_company_name" />
          Vendor Company Name:&ensp;
          <span class="font-weight-bold">{{
            generalData.pbx_vendor_company_name
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.pbx_vendor_company_number" />
          Vendor Company Number:&ensp;
          <span class="font-weight-bold">{{
            generalData.pbx_vendor_company_number
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.pbx_vendor_contact_name" />
          Vendor Contact Name:&ensp;
          <span class="font-weight-bold">{{
            generalData.pbx_vendor_contact_name
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.pbx_vendor_contact_number" />
          Vendor Contact Number:&ensp;
          <span class="font-weight-bold">{{
            generalData.pbx_vendor_contact_number
          }}</span>
        </div>
        <div>
          <ValidationIcon :value="generalData.pbx_vendor_contact_email" />
          Vendor Contact Email:&ensp;
          <span class="font-weight-bold">{{
            generalData.pbx_vendor_contact_email
          }}</span>
        </div>
      </div>
    </section>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from 'lodash';
import ValidationIcon from "@/components/indicators/ValidationIcon.vue";

export default {
  name: "Review",
  data() {
    return {
      generalData: {},
      products: [],
      addedStates: [],
      allStates: [
        "AL",
        "AR",
        "AZ",
        "CA",
        "CO",
        "CT",
        "DC",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IA",
        "KS",
        "KY",
        "ME",
        "MD",
        "MI",
        "MN",
        "MO",
        "NE",
        "NV",
        "NJ",
        "NM",
        "NC",
        "ND",
        "OH",
        "OK",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "WA",
        "WI",
      ],
    };
  },
  computed: {
    /* eslint-disable */
    ...mapGetters(["getFormData", "getProducts", "getProvisions", "isExistingCustomer", "isRetail"]),
    getProvisionText() {
        return (this.getProvisions.filter((provision) => provision.value === this.generalData.fedtax_exemption_provision))[0]?.label;
    },
  },
  mounted() {
      this.generalData = this.getFormData.general;
      this.getProducts.forEach((product) => {
          if (product.is_voice) {
              this.products.push({
                  product_name: product.product_name,
                  usf_exempt: (this.getFormData[`${product.product_id}`] || {}).is_usf_exempt,
                  product_id: product.product_id,
              });
          }
      });
      this.populateAddedStates();
  },
  methods: {
      ...mapActions(["setSubTab"]),
      goToStep(tab) {
          this.setSubTab(tab);
      },
      populateAddedStates() {
          const vm = this;
          _.forEach(vm.allStates, (state) => {
              if (vm.generalData[`statetax_${state.toLowerCase()}_id`] != null) {
                  vm.addedStates.push(state);
              }
          });
      },
  },
  components: { ValidationIcon }
};
</script>

<style lang="scss" scoped>
.link {
  cursor: pointer;
}
</style>
